import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationBranchActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Branch/BranchBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationBranch"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationBranch"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationBranchActivity)
